import * as React from 'react';
import { useState, useEffect } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import {
  listPossibleLeaveReasons,
  listPossibleLeaveParticipants,
} from '../../redux/actions/table/timesheets';
import styles from '../../styles/forms/add_timesheet_wizard/AddTimeOffForm.scss';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Checkbox from '../../components/Checkbox';
import PeopleChooser from '../../components/PeopleChooser';
import DateTimePicker from '../../components/DateTimePicker';

const AddTimeOffForm = (props) => {
  const [possible_leave_reasons, set_possible_leave_reasons] = useState([]);
  const [possible_leave_participants, set_possible_leave_participants] =
    useState([]);
  const [filteredParticipants, setFilteredParticipants] = useState([]);

  useEffect(() => {
    listPossibleLeaveReasons().then(({ response }) => {
      set_possible_leave_reasons(response.data);
    });

    listPossibleLeaveParticipants().then(({ response }) => {
      set_possible_leave_participants(
        _.map(response.data, (row) => ({
          ...row,
          name: row.fullname,
        }))
      );
    });
  }, []);

  const { values, auth } = props;

  const possibleMinutes = [
    { value: '0', label: '00' },
    { value: 15, label: '15' },
    { value: 30, label: '30' },
    { value: 45, label: '45' },
  ];

  useEffect(() => {
    const currentUserId = auth?.id;
    const selectedUserId = values?.user_id;

    if (selectedUserId === currentUserId) {
      setFilteredParticipants(
        possible_leave_participants.filter((user) => user.id !== currentUserId)
      );
    } else {
      setFilteredParticipants(possible_leave_participants);
    }
  }, [values?.user_id, possible_leave_participants, auth?.id]);

  return (
    <Form className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          {_.includes(auth?.permissions, 'create.any.leave.request') && (
            <Field
              name='user_id'
              component={Select}
              searchable
              options={[
                ..._.map(possible_leave_participants, (row) => ({
                  value: row.id,
                  label: row.fullname,
                })),
              ]}
              label={__('table.columns.timesheet-users')}
              placeholder={__('add-timesheet-form.select-user')}
            />
          )}
        </div>
        <div className={styles.flex}>
          <Field
            name='all_day'
            component={Checkbox}
            label={__('add-timesheet-form.all_day')}
            className={styles.checkbox}
          />
        </div>

        {values?.all_day ? (
          <div>
            <Field
              name='date'
              component={DateTimePicker}
              label={__('table.columns.task-date-time')}
              footer
              range
              presets
            />
          </div>
        ) : (
          <>
            <div className={styles.flex}>
              <div className={styles.f2}>
                <Field
                  name='date'
                  component={DateTimePicker}
                  label={__('table.columns.timesheet-date')}
                  footer
                />
              </div>
              <div className={styles.f2}>
                <Field
                  name='hours'
                  component={Input}
                  label={__('table.columns.timesheet-hours')}
                  numeric
                  maxLength={2}
                  hint={__('timesheets.hint.in-hours')}
                />
              </div>
              <div className={styles.f2}>
                <Field
                  name='minutes'
                  component={Select}
                  searchable
                  options={possibleMinutes}
                  label={__('table.columns.timesheet-minutes')}
                />
              </div>
            </div>
          </>
        )}

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='reason'
              component={Select}
              searchable
              options={_.map(possible_leave_reasons, (leaveReason) => ({
                value: leaveReason.id,
                label: leaveReason.name,
              }))}
              label={__('table.columns.timesheet-reason')}
              placeholder={__('add-timesheet-form.select-reason')}
            />
          </div>
        </div>
        <Field
          name='description'
          component={Textarea}
          label={__('add-timesheet-form.description')}
          maxLength={200}
          rows={1}
          maxRows={5}
          placeholder={__('add-timesheet-form.add-description')}
        />
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='approvers'
              component={PeopleChooser}
              label={__('table.columns.timesheet-approvers')}
              searchable
              options={filteredParticipants}
              placeholder={__('add-timesheet-form.select-approvers')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='followers'
              component={PeopleChooser}
              label={__('table.columns.timesheet-followers')}
              searchable
              options={filteredParticipants}
              placeholder={__('add-timesheet-form.select-followers')}
            />
          </div>
        </div>

        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={props.actions.hideAddTimesheetWizard}
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              middleText={__('button.create')}
              spinning={props.submitting}
              onClick={() => props.submit()}
            />
          </ButtonGroup>
        </div>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    values: getFormValues('add_timesheet_wizard.time_off')(state),
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      hideAddTimesheetWizard: () =>
        dispatch({
          type: 'table.timesheets/SET_TABLE_PARAMS',
          params: {
            wizard_timesheet_add: undefined,
            task_id: undefined,
          },
        }),
    },
  };
};

export default withRouter(
  reduxForm({
    form: 'add_timesheet_wizard.time_off',
  })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(subscribe(Localization, 'localization')(AddTimeOffForm))
  )
);
